
export enum MetricTypeCd {
	ROUTE = 'Route',
	SERVICE_CENTER = 'ServiceCenter',
	TRIP = 'Trip'}

